import { TranslationKey } from '../../../../types/translation/TranslationKey';
import { t } from '../../../../types/translation/Translator';
import { BaseFilterProps } from '../common/BaseFilter';
import { UserFilter } from '../UserFilter';

export class AssignedToFilter extends UserFilter {
  toLabel(props: BaseFilterProps): string {
    return t(TranslationKey.assignedTo).singular.label;
  }
}
